module.exports = __webpack_public_path__ + "static/media/roboto-500.020c97dc.woff2";